import dayjs from 'utils/extendedDayJS';
import { convertSendAtToFormValue } from 'pages/dashboard/overview/events/schemas/commonUtils';

export const POST_EVENT_REMINDER_WINDOW_DAYS = 30;

export const getPostEventReminderWindowEnd = (datetimeEnd?: string | null): dayjs.Dayjs | null => {
  if (!datetimeEnd) return null;

  return dayjs.utc(datetimeEnd).add(POST_EVENT_REMINDER_WINDOW_DAYS, 'day');
};

const REMINDER_DEFAULT_BUFFER_MINUTES = 15;
const REMINDER_TIME_PICKER_INTERVAL_MINUTES = 5;

export const getDefaultPostEventReminderSendAtFormValue = ({
  datetimeEnd,
  timezoneCode
}: {
  datetimeEnd?: string | null;
  timezoneCode: string;
}): Date => {
  const bufferedNowInEventTimezone = dayjs()
    .tz(timezoneCode)
    .add(REMINDER_DEFAULT_BUFFER_MINUTES, 'minute')
    .second(0)
    .millisecond(0);
  const minutesUntilNextTick =
    (REMINDER_TIME_PICKER_INTERVAL_MINUTES -
      (bufferedNowInEventTimezone.minute() % REMINDER_TIME_PICKER_INTERVAL_MINUTES)) %
    REMINDER_TIME_PICKER_INTERVAL_MINUTES;
  const roundedDefault = bufferedNowInEventTimezone.add(minutesUntilNextTick, 'minute');
  const windowEnd = getPostEventReminderWindowEnd(datetimeEnd);
  const defaultSendAt =
    windowEnd && roundedDefault.utc().isAfter(windowEnd) ? windowEnd : roundedDefault;

  return convertSendAtToFormValue(dayjs.formatForDB(defaultSendAt), timezoneCode);
};

export const isWithinPostEventReminderWindow = (datetimeEnd?: string | null): boolean => {
  const windowEnd = getPostEventReminderWindowEnd(datetimeEnd);

  if (!windowEnd) return false;

  return !dayjs.utc().isAfter(windowEnd);
};

export const canManagePostEventReminders = ({
  datetimeEnd,
  hasEnded,
  scheduledDeletionAt
}: {
  datetimeEnd?: string | null;
  hasEnded?: boolean | null;
  scheduledDeletionAt?: string | null;
}): boolean => {
  if (scheduledDeletionAt) return false;
  if (!hasEnded) return true;

  return isWithinPostEventReminderWindow(datetimeEnd);
};
